// TEMPORARY COMPATIBILITY SHIM — safe to delete at the next unrelated release.
//
// The "consistent-route-names" rename (merged into dev as d66c7b139) changed
// several route names and param keys. A browser tab left open across that
// deploy can still have a pre-rename route name/params stored in
// `sessionStorage.userRequestUrl` (see middleware/auth.js) when the user logs
// back in on the new build. This map translates those stale requests to
// their current equivalent so the user lands where they intended instead of
// just falling back to their company home.
//
// To remove: delete this file and its one usage in
// store/modules/auth/actions.js once we're confident no client still has a
// pre-rename `userRequestUrl` sitting in sessionStorage (i.e. everyone has
// gone through at least one fresh login since the deploy).

const legacyRouteMigrations = {
  'tenant-admin-update': (params) => ({
    name: 'tenant-admin-edit',
    params: { ...params, user_id: params.id },
  }),
  'v-ai-admin-panel-email-inbox-new': (params) => ({
    name: 'v-ai-admin-panel-email-inbox-create',
    params,
  }),
  'v-ai-admin-panel-browser-automation-new': (params) => ({
    name: 'v-ai-admin-panel-browser-automation-create',
    params,
  }),
  'v-ai-admin-panel-browser-automation-edit': (params) => ({
    name: 'v-ai-admin-panel-browser-automation-edit',
    params: { ...params, browser_automation_id: params.id },
  }),
  'admin-automation-new': (params) => ({
    name: 'admin-automation-create',
    params,
  }),
  'admin-automation': (params) => ({
    name: 'admin-automation-edit',
    params,
  }),
  'admin-validation-new': (params) => ({
    name: 'admin-validation-create',
    params,
  }),
  'admin-validation': (params) => ({
    name: 'admin-validation-edit',
    params,
  }),
  // Create vs. edit used to be the same route with an optional `form_id`.
  'admin-v-form-builder': (params) => (
    params.form_id
      ? { name: 'admin-v-form-edit', params }
      : { name: 'admin-v-form-create', params }
  ),
  resource: (params) => ({
    name: 'resource',
    params: { ...params, resource_id: params.resourceId },
  }),
  'user-settings': (params) => ({
    name: 'user-edit',
    params: { ...params, user_id: params.userId },
  }),
}

export default legacyRouteMigrations
